function getOffsetTop(element) {
      let yPosition = 0;
      let nextElement = element;
      while (nextElement) {
        yPosition += (nextElement.offsetTop);
        nextElement = nextElement.offsetParent;
      }
      console.log('elements y Offset: ', element, yPosition);
      return yPosition;
    }

module.exports = getOffsetTop



// WEBPACK FOOTER //
// ./public/src/getOffsetTop.js